import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import ErrorScreen, {
  ErrorScreenType,
} from 'shared/patterns/vxl/errors/ErrorScreen/ErrorScreen';
import theme from 'shared/styles/theme';

const CstVerifyFailure = () => {
  const { t: translatedText } = useTranslation('cstVerify');

  const headline = translatedText('linkExpired.header');
  const body = translatedText('linkExpired.body');
  const screenCustomAttributes = {
    error_type: 'link_expired',
  };

  return (
    <View style={styles.container}>
      <ErrorScreen
        messageHeadline={headline}
        messageBody={body}
        primaryButton={undefined}
        secondaryButton={undefined}
        screenType={ErrorScreenType.Error}
        screenAnalyticsEventKey="/challenge/cst-link/verify-error"
        customAttributes={screenCustomAttributes}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: theme.color.background.primary,
    flex: 1,
    justifyContent: 'flex-start',
    minWidth: '100%',
    paddingHorizontal: theme.spacing.m,
    paddingVertical: theme.spacing.m,
  },
});

export default CstVerifyFailure;
